<template>
    <b-card class="px-0 py-0">
      <b-row class="px-1 align-items-center justify-content-between">
        <h5> التعاون بين شريكين محليين </h5>
      </b-row>
      <hr />
      <data-table
        ep="v2/collaboration-two-local-partners"
        id="projects"
        :fields="tableFields"
        striped
        ref="collaborationsTable"
      >
        <template #cell(partner_entity)="{ value }" >
          <partner-entity-formatter :value="value" ></partner-entity-formatter>
        </template>
        <template #cell(file)="{ value }" >
          <b-button
            size="sm"
            @click="$router.push({ name: 'file-view', query: { ep: value } })"
            variant="flat-success"
          >

            <feather-icon class="mx-25" icon="EyeIcon" />
            عرض الملف
          </b-button>
        </template>

        <template #cell(_)="row">
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="flat-info"
              @click="row.toggleDetails"
              title="عرض المزيد من المعلومات"
              size="sm"
              class="btn-icon rounded-circle"
              v-b-tooltip.hover.v-info.top
            >
              <feather-icon icon="InfoIcon" size="1.8x" color="#4fc98c" />
            </b-button>
          </div>
        </template>
        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col md="12" class="mb-1 d-flex">
                <strong>غاية التعاون :</strong>
                <div class="text-info mx-1" v-html="row.item.goal_of_cooperation"></div>
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              عرض اقل
            </b-button>
          </b-card>
        </template>
      </data-table>
    </b-card>
  </template>

  <script>
  import { BCard, BCol , BRow, BButton , BDropdown, BDropdownItem, VBTooltip} from "bootstrap-vue";
  import DataTable from "@/components/data-table";
  import Ripple from "vue-ripple-directive";
  import PartnerEntityFormatter from "../../components/PartnerEntityFormatter.vue";

  export default {
    components: {
      BCard,
      BCol ,
      BRow,
      DataTable,
      BButton,
      BDropdown,
      BDropdownItem,
      VBTooltip,
      PartnerEntityFormatter
    },
    data() {
      return {
        collaborationModal : false ,
        tableFields: [
          { key: "id", label: "المعرف" },
          { key: "ngo.name_ar", label: "اسم المنظمة" },
          { key: "partner_entity", label: "الجهة الشريكة" },
          { key: "partner_entity_name", label: "اسم الجهة الشريكة" },
          { key: "duration", label: "مدة التعاون" },
          { key: "file", label: "وثيقة التعاون" },
          "_",
        ],
        form : {}
      };
    },
    directives: {
      "b-tooltip": VBTooltip,
      Ripple,
    },
  };
  </script>
